module.exports = __webpack_public_path__ + "static/media/support.9c443bab.png";